module.exports = __webpack_public_path__ + "img/studentTax.91ee6508.svg";